//put jquery at first
import $ from "jquery";


window.$ = $;
window.jQuery = $;

